module.exports = __webpack_public_path__ + "images/help/video-ical-f72d62b44280f4a814f2aa44ccac4869.png";